import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import '../../../index.css';
import Title from '../../../components/Title';
import GuideModal from '../../../components/GuideModal';

import {
  getContentsList,
  getUserDetail,
} from '../../../modules/NetworkFunction';

import AuthContext from '../../../contexts/AuthContext';
import styled from 'styled-components';
import PreviewPage from '../Preview/PreviewPage';
import Modal from '../../Modal';
import usePaymentStatus from '../../../hooks/usePaymentStatus';
import checkedIcon from '../../../icons/ic-checked-yellow.png';
import ShopModeContext from '../../../contexts/ShopModeContext';

function ContentsManagement({ history }) {
  // 다른 페이지에서 props 받아오기위한 함수
  const location = useLocation();
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);
  const [contentsList, setContentsList] = useState([]);
  const [isContentsListLoaded, setIscontentsListLoaded] = useState(false);
  const [shopVersion, setShopVersion] = useState(
    location.state.isMobile ? 'mobile' : 'pc'
  ); //쇼핑몰 버전( pc or mobile)

  const [selectedContentsNo, setSelectedContentsNo] = useState(
    location.state.contentsNo
  );

  const publishedContents = location.state.publishedContents;

  const [isModify, setIsModify] = useState(location.state.isModify);
  const [contentStyle, setContentStyle] = useState('');

  const [user, setUser] = useState();
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const { isPaid } = usePaymentStatus(token);

  // 상세페이지 경로
  const [detailPagePath, setDetailPagePath] = useState('/product/detail.html');
  //가이드
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isUserLoaded) {
      getUserDetail(
        null,
        (v) => {
          setUser(v.user);
        },
        setIsUserLoaded,
        (e) => {
          console.log('user error', e);
        },
        token
      );
    }
  }, []);

  useEffect(() => {
    // 새로 게시하는 건지, 게시한 콘텐츠를 수정하는 건지 판별하기 위한 isModify변수 세팅
    setIsModify(location.state.isModify);

    if (!isContentsListLoaded) {
      getContentsList(
        null,
        setContentsList,
        setIscontentsListLoaded,
        (e) => {
          console.log(e);
        },
        token
      ).then(() => {});
    }
  }, [contentsList, isModify]);

  const handleNextBtn = () => {
    history.push({
      pathname: '/mypage/content-design-management',
      state: {
        user,
        isPaid,
        isModify,
        shopVersion,
        publishedContents,
        contentsNo: selectedContentsNo,
        style: contentStyle,
        detailPagePath:
          shopMode === 'cafe24'
            ? detailPagePath + '?product_no='
            : '/shop/shopdetail.html?branduid=',
      },
    });
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };

  const handleChangeVersion = (version) => {
    if (
      !isPaid &&
      location.state.publishedMobileContentsCount >= 1 &&
      version === 'mobile'
    ) {
      alert('무료 요금제는 1개의 모바일 콘텐츠만 노출할 수 있습니다.');
      return;
    }

    if (
      !isPaid &&
      location.state.publishedPCContentsCount >= 1 &&
      version === 'pc'
    ) {
      alert('무료 요금제는 1개의 PC 콘텐츠만 노출할 수 있습니다.');
      return;
    }

    if (isModify && publishedContents) {
      // 게시된 콘텐츠 수정 시 콘텐츠가 pc 또는 모바일 둘 중 하나에 게시되어있는 경우
      alert('콘텐츠 수정 시에는 PC, 모바일 변경이 불가능합니다.');
      return;
    }

    setShopVersion(version);
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {/* 미리보기 페이지 모달 */}
      <Modal open={isPreviewModalOpen}>
        <PreviewPage
          closeModal={closePreviewModal}
          contentsNo={selectedContentsNo}
          contentStyle={contentStyle}
          onSelectContentStyle={setContentStyle}
          shopVersion={shopVersion}
          publishedContents={publishedContents}
        />
      </Modal>

      <Title title="콘텐츠 설정" />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'center',
          marginTop: 10,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <input
            type="radio"
            name="version"
            id="pc"
            value="pc"
            checked={shopVersion === 'pc'}
            onChange={() => {
              handleChangeVersion('pc');
            }}
            onClick={() => {
              setContentStyle('');
            }}
          />
          <label htmlFor="pc">PC</label>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <input
            type="radio"
            name="version"
            id="mobile"
            value="mobile"
            checked={shopVersion === 'mobile'}
            onChange={() => {
              handleChangeVersion('mobile');
            }}
            onClick={() => {
              setContentStyle('');
            }}
          />
          <label htmlFor="mobile">모바일</label>
        </div>
      </div>
      <div className="inner-box">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 15,
            width: 665,
          }}
        >
          <p className="subtitle" style={{ marginBottom: 0 }}>
            콘텐츠 형태
          </p>
          <PreviewButton
            onClick={openPreviewModal}
            disabled={!selectedContentsNo}
          >
            미리보기
          </PreviewButton>
        </div>

        {
          // 콘텐츠 형태 선택
          shopVersion === 'pc' ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 30,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '배너 가로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="banner_h"
                    value="banner_h"
                    onChange={(event) => {
                      setContentStyle('배너 가로');
                    }}
                    checked={contentStyle === '배너 가로'}
                  />

                  <label htmlFor="banner_h"></label>
                  <p style={{ color: '#b5b5b5' }}>배너 가로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '배너 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="banner_v"
                    value="banner_v"
                    checked={contentStyle === '배너 세로'}
                    onChange={(event) => {
                      setContentStyle('배너 세로');
                    }}
                  />
                  <label htmlFor="banner_v"></label>
                  <p style={{ color: '#b5b5b5' }}>배너 세로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 가로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="popup_h"
                    value="popup_h"
                    checked={contentStyle === '팝업 가로'}
                    onChange={(event) => {
                      setContentStyle('팝업 가로');
                    }}
                  />
                  <label htmlFor="popup_h"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 가로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="popup_v"
                    value="popup_v"
                    checked={
                      shopVersion === 'pc' && contentStyle === '팝업 세로'
                    }
                    onChange={(event) => {
                      setContentStyle('팝업 세로');
                    }}
                  />
                  <label htmlFor="popup_v"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 세로</p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '서랍형' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="drawer"
                    value="drawer"
                    checked={shopVersion === 'pc' && contentStyle === '서랍형'}
                    onChange={() => {
                      setContentStyle('서랍형');
                    }}
                  />
                  <label htmlFor="drawer"></label>
                  <p style={{ color: '#b5b5b5' }}>서랍형</p>
                </div>
              </div>
              <div style={{ marginTop: 15 }}>
                <p style={{ color: '#848484', fontSize: 13 }}>
                  {' '}
                  *여러 형태로 동시에 노출을 원하는 경우, 하나의 형태에서 게시를
                  완료한 후 다시 콘텐츠 게시하기를 실행해주세요.
                </p>
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 30,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents_mobile"
                    id="popup_v_mobile"
                    value="popup_v_mobile"
                    checked={
                      shopVersion === 'mobile' && contentStyle === '팝업 세로'
                    }
                    onChange={(event) => {
                      setContentStyle('팝업 세로');
                    }}
                  />
                  <label htmlFor="popup_v_mobile"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 세로</p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '서랍형' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents_mobile"
                    id="drawer_mobile"
                    value="drawer_mobile"
                    checked={
                      shopVersion === 'mobile' && contentStyle === '서랍형'
                    }
                    onChange={(event) => {
                      setContentStyle('서랍형');
                    }}
                  />
                  <label htmlFor="drawer_mobile"></label>
                  <p style={{ color: '#b5b5b5' }}>서랍형</p>
                </div>
              </div>
              <div style={{ marginTop: 15 }}>
                <p style={{ color: '#848484', fontSize: 13 }}>
                  *여러 형태로 동시에 노출을 원하는 경우, 하나의 형태에서 게시를
                  완료한 후 다시 콘텐츠 게시하기를 실행해주세요.
                </p>
              </div>
            </div>
          )
        }
      </div>

      {isModify ? null : (
        <>
          <div className="inner-box">
            <p className="subtitle">콘텐츠 선택</p>
            <div className="input-box">
              <select
                style={{
                  width: 560,
                  height: 45,
                  cursor: 'pointer',
                  padding: 5,
                }}
                onChange={(e) => {
                  setSelectedContentsNo(e.target.value);
                }}
                value={selectedContentsNo}
              >
                <option value="" hidden>
                  내 콘텐츠 목록
                </option>
                {contentsList.map((item, idx) => (
                  <option key={idx} value={item.contentsNo}>
                    {item.title || '제목 없음'}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {shopMode === 'cafe24' && (
            <div className="inner-box">
              <div
                style={{
                  width: 560,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <p className="subtitle">콘텐츠 상세페이지 경로</p>
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <img src="/icons/ic-question-mark.png" alt="help" />
                  <p
                    style={{
                      color: '#FF7A00',
                      cursor: 'pointer',
                      fontSize: 14,
                      marginLeft: 8,
                      textDecoration: isHovered ? 'underline' : 'none',
                      lineHeight: isHovered ? 'normal' : 'initial',
                    }}
                  >
                    가이드
                  </p>
                  {isHovered && (
                    <GuideModal
                      videoLink="https://www.youtube.com/watch?v=OZlIWSKTLnw"
                      pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/wizmon_product_detail_guide.pdf"
                    />
                  )}
                </div>
              </div>

              <input
                type="text"
                placeholder="붙여넣기"
                style={{
                  width: 560,
                  height: 45,
                  padding: 10,
                  background: 'rgba(231, 231, 231, 0.3)',
                  color: '#848484',
                }}
                value={detailPagePath}
                onChange={(e) => {
                  setDetailPagePath(e.target.value);
                }}
              />
              <p style={{ color: '#848484', fontSize: 12, marginTop: 6 }}>
                * 위즈몬 콘텐츠에서 상세페이지로 이동하는 경우, 가이드를
                참고하여 주소를 붙여 넣어주세요.
              </p>
            </div>
          )}
        </>
      )}

      <button
        disabled={
          !contentStyle || (!isModify && selectedContentsNo === undefined)
        }
        style={{
          display: 'flex',
          height: 40,
          borderRadius: 20,
          position: 'absolute',
          right: 0,
          bottom: 50,
          backgroundColor:
            !contentStyle || (!isModify && selectedContentsNo === undefined)
              ? '#CCC'
              : '#FFB600',
          color:
            !contentStyle || (!isModify && selectedContentsNo === undefined)
              ? '#4D4D4D'
              : '#FFF',
          fontSize: 20,
          borderWidth: 0,
          cursor: 'pointer',
          fontFamily: 'Noto Sans',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          padding: '10px 30px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={handleNextBtn}
      >
        다음
      </button>
    </div>
  );
}
export default ContentsManagement;

const PreviewButton = styled.button`
  height: 27px;
  border-radius: 30px;
  border: 1px solid #ff7a00;
  padding: 0px 12px;
  background-color: white;
  color: #ff7a00;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`;
